import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { AppTileConfig } from '../../models/application.model';

@Component({
  selector: 'app-application-tile',
  standalone: true,
  imports: [MatCardModule, MatIconModule, MatRippleModule],
  templateUrl: './application-tile.component.html',
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class ApplicationTileComponent {
  @Input({ required: true }) application!: AppTileConfig;

  navigate(): void {
    if (this.application.externalUrl) {
      window.open(this.application.url, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = this.application.url;
    }
  }
}
